var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Tạo nhóm quyền"}},[_c('span',{staticStyle:{"color":"darkred"},attrs:{"slot":"extra"},slot:"extra"},[_vm._v("Để trống bưu cục nếu tạo quyền hệ thống")]),_c('role-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }